import { render, staticRenderFns } from "./task-view-header.vue?vue&type=template&id=352d66d1&scoped=true&"
import script from "./task-view-header.vue?vue&type=script&lang=js&"
export * from "./task-view-header.vue?vue&type=script&lang=js&"
import style0 from "./task-view-header.vue?vue&type=style&index=0&lang=css&"
import style1 from "./task-view-header.vue?vue&type=style&index=1&id=352d66d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d66d1",
  null
  
)

export default component.exports